<template>
  <div :class="[classes, width]" class="justify-between">
    <div class="flex flex-col justify-between h-full w-3/4">
      <div class="w-full flex flex-col items-start">
        <slot name="main">
        </slot>
      </div>
      <div class="flex flex-col w-full place-self-end">
        <slot name="footer">
        </slot>
      </div>
    </div>
    <div :class="buttonsClasses" class="place-self-end">
      <slot name="buttons">
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      directionClass: {
        horizontal: 'flex flex-row',
        vertical: 'flex flex-col space-y-2',
      },
      widthClass: {
        full: 'w-full',
        fit: 'w-fit',
        half: 'w-1/2',
        quarter: 'w-full md:w-1/4',
      },
    };
  },
  props: {
    direction: {
      type: String,
      default: 'horizontal',
    },
    width: {
      type: String,
      default: 'w-full',
    },
    elementsColor: {
      type: String,
    },
    buttonsDirection: {
      type: String,
      default: 'horizontal',
    },
    buttonsWidth: {
      type: String,
      default: 'full',
    },
  },
  computed: {
    classes() {
      return `${this.directionClass[this.direction]} ${this.elementsColor}`;
    },
    buttonsClasses() {
      return `${this.directionClass[this.buttonsDirection]} ${this.widthClass[this.buttonsWidth]}`;
    },
  },
};
</script>
